import React from 'react';
import ReactDOM from 'react-dom';
import SouthernLivingHome2025 from './southern-living/apps/SouthernLivingHome2025/SouthernLivingHome2025';
import '../scss/southern-living.scss';

console.log('THIS GOT LOADED IN');
const App = () => <SouthernLivingHome2025 />;

ReactDOM.render(< App />, document.getElementById('app-southern-living-2025'));